import { createContext, useContext } from 'react'
import { TutorialContextType } from './tutorial-context.def'

export const TutorialContext = createContext<TutorialContextType | undefined>(
  undefined
)

export const useTutorial = () => {
  const context = useContext(TutorialContext)
  if (!context) {
    throw new Error('useTutorial must be used within TutorialProvider')
  }
  return context
}
